import { Card, Select, II18NValued, Footer, LinkedField, Input } from '@2r/frontend-component-library';
import { useEffect, useRef, useState } from 'react';
import { useModul } from '../Hooks/useModul';
import { EnumInterfaceType } from '../model/EnumInterfaceType';
import { VmPartnership } from '../model/VmPartnership';
import { VmUser } from '../model/VmUser';

interface IEditProps {
    New?: boolean;
}

export function FrameEditPartnership({ New } : IEditProps) {
    const modul = useModul<VmPartnership>("/partnerships", "partnershipID", New);
    const key = useRef(0);

    const [partnership, setPartnership] = useState<VmPartnership | undefined>();

    useEffect(() => {
        if (!modul.isLoading) {
            setPartnership(modul.data);
        }
    }, [modul.isLoading, modul.data]);

    if (modul.isLoading) {
        return <div>Loading...</div>;
    }
    else if (partnership === undefined) {
        return (
            <div>
                Die Partnerschaft mit der ID {modul.primaryKey} konnte nicht geladen werden.
            </div>
        );
    }
    else {
        const interfaces: II18NValued<number>[] = [
            { Name: "None", Label: "Bitte wählen", Value: EnumInterfaceType.NotDefined },
            { Name: "AVAL", Label: "AvaL", Value: EnumInterfaceType.AVAL },
        ];

        function setPartner(user: VmUser, partnerNo: number): void {
            console.log(user);
            if (partnership === undefined) {
                return;
            } else if (partnerNo === 1) {
                if (user === undefined) {
                    setPartnership({
                        ...partnership,
                        partner1ID: '',
                        partner1: ''
                    });
                } else {
                    setPartnership({
                        ...partnership,
                        partner1ID: user.id,
                        partner1: user.username
                    });
                }
            } else {
                if (user === undefined) {
                    setPartnership({
                        ...partnership,
                        partner2ID: '',
                        partner2: ''
                    });
                } else {
                    setPartnership({
                        ...partnership,
                        partner2ID: user.id,
                        partner2: user.username
                    });
                }
            }

            key.current++;
        }
        
        return (
            <div key={key.current}>
                <h2>Partnerschaft bearbeiten</h2>
                <Card Name="Kopfdaten" Label="Kopfdaten">
                    <Input
                        Name="ID"
                        Label="ID"
                        value={partnership.id}
                        locked
                    />
                    <LinkedField<VmUser>
                        type="string"
                        Name="Partner1"
                        Label="Partner 1"
                        linked_key={partnership.partner1ID}
                        value={partnership.partner1}
                        apiPath={'/users'}
                        onConfirm={(_: string, user: VmUser) => setPartner(user, 1)}
                    />
                    <LinkedField<VmUser>
                        type="string"
                        Name="Partner2"
                        Label="Partner 2"
                        linked_key={partnership.partner2ID}
                        value={partnership.partner2}
                        apiPath={'/users'}
                        onConfirm={(_: string, user: VmUser) => setPartner(user, 2)}
                    />
                    <Select
                        locked={!New}
                        Name="Interface"
                        Label="Schnittstelle"
                        Items={interfaces}
                        value={partnership.interface}
                        onChange={(v: string) => partnership.interface = +v}
                        Required
                    />
                </Card>
                <Footer
                    New
                    onSave={New ? () => modul.onLeave(1, partnership) : undefined}
                    onCancel={() => modul.onLeave(2, partnership)}
                    onDelete={() => false}
                />
            </div>
        );
    }
}